import mergeByProp from '../../../lib/mergeByProp.js';
import formatPipelines from "../../lib/formatPipelines";

const currentServiceProviderReducerPipelinesSlice = {
  SET_SELECTED_PIPELINE_PIPELINES_VIEW: (state, payload) => {
    return {
      ...state,
      selectedPipelineId: payload.selectedPipelineId,
    };
  },

  POST_PIPELINE_SUCCESS: (state, payload) => {
    const pipelinesCopy = [...state.pipelines];
    pipelinesCopy.push(payload.data);
    return {
      ...state,
      pipelines: pipelinesCopy,
    };
  },

  PATCH_PIPELINE_STAGE_ORDER_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: state.pipelines.map((n) => {
      return n.id === payload.data[0].pipeline_id ? { ...n, stages: payload.data } : n;
    }),
  }),

  POST_PIPELINE_STAGE_SUCCESS: (state, payload) => {
    const pipelineId = ((payload.data || [])[0] || {}).pipeline_id;
    return {
      ...state,
      pipelines: (state.pipelines || []).map((n) => (n.id !== pipelineId ? n : { ...n, stages: payload.data })),
    };
  },

  DELETE_PIPELINE_STAGE_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: (state.pipelines || []).map((pipeline) => ({
      ...pipeline,
      stages: (pipeline.stages || []).filter((n) => parseFloat(n.id) !== parseFloat(payload.data)),
    })),
  }),

  PATCH_PIPELINE_NAME_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: mergeByProp('id', state.pipelines, [payload.data]),
  }),

  PATCH_PIPELINE_STAGE_SUCCESS: (state, payload) => {
    const pipelineID = payload.data[0].pipeline_id;
    const pipelinesCopy = [...state.pipelines];
    const withUpdatedStageNames = pipelinesCopy.map((item) => {
      if (item.id === pipelineID) {
        const object = { ...item };
        object.stages = payload.data;
        return object;
      }
      return item;
    });
    return {
      ...state,
      pipelines: withUpdatedStageNames,
    };
  },

  PATCH_STAGE_IS_MILESTONE_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: state.pipelines.map((n) => {
      return n.id === payload.data[0].pipeline_id ? { ...n, stages: payload.data } : n;
    }),
  }),

  POST_RECOMMENDED_ACTION_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: state.pipelines.map((pipeline) => ({
      ...pipeline,
      stages: (pipeline.stages || []).map((stage) => ({
        ...stage,
        actions: stage.id !== payload.data.stage_id ? stage.actions : [...(stage.actions || []), payload.data],
      })),
    })),
  }),

  PATCH_RECOMMENDED_ACTION_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: state.pipelines.map((pipeline) => ({
      ...pipeline,
      stages: (pipeline.stages || []).map((stage) => ({
        ...stage,
        actions: (stage.actions || []).map((n) => (n.id !== payload.data.id ? n : { ...n, ...payload.data })),
      })),
    })),
  }),

  DELETE_RECOMMENDED_ACTION_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: state.pipelines.map((pipeline) => ({
      ...pipeline,
      stages: (pipeline.stages || []).map((stage) => ({
        ...stage,
        actions: (stage.actions || []).filter((n) => n.id !== payload.data),
      })),
    })),
  }),

  GET_PIPELINE_SUCCESS: (state, payload) => ({
    ...state,
    pipelines: formatPipelines(mergeByProp('id', state.pipelines, [payload.data])),
  }),
};

export default currentServiceProviderReducerPipelinesSlice;
